import template from "./new_feature_tag.html";
import en from "./en.json";
import es from "./es.json";

export default {
    template: template,
    name: "newFeatureTag",
    translations: { en, es },
};
